import { parseToRgb } from "polished";
import { useEffect, useRef, useState } from "react";
/**
 * Check the element or up to 10 parent elements for the computed background
 * color
 */
const useComputedBackgroundColor = () => {
    const [color, setColor] = useState("computing");
    const ref = useRef(null);
    useEffect(() => {
        setColor("computing");
        let elemToCheck = ref.current;
        let backgroundColorFound = false;
        // check up to 3 parents for a computed background color
        for (let i = 0; i < 10 && elemToCheck; i++) {
            const backgroundColor = window.getComputedStyle(elemToCheck).backgroundColor;
            if (!backgroundColor) {
                elemToCheck = elemToCheck.parentElement;
                continue;
            }
            const rgba = parseToRgb(backgroundColor);
            // alpha == 0 ~> no background color set
            if ("alpha" in rgba && rgba.alpha === 0) {
                // continue with next parent
                elemToCheck = elemToCheck.parentElement;
                continue;
            }
            setColor(rgba);
            backgroundColorFound = true;
            break;
        }
        if (!backgroundColorFound) {
            setColor(undefined);
        }
    }, [ref.current]);
    return {
        backgroundColor: color,
        ref,
    };
};
export default useComputedBackgroundColor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQ29tcHV0ZWRCYWNrZ3JvdW5kQ29sb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlQ29tcHV0ZWRCYWNrZ3JvdW5kQ29sb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUV0QyxPQUFPLEVBQW9CLFNBQVMsRUFBRSxNQUFNLEVBQUUsUUFBUSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBYXRFOzs7R0FHRztBQUNILE1BQU0sMEJBQTBCLEdBQUcsR0FFUyxFQUFFO0lBQzVDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLEdBQUcsUUFBUSxDQUEwQixXQUFXLENBQUMsQ0FBQztJQUN6RSxNQUFNLEdBQUcsR0FBRyxNQUFNLENBQU8sSUFBSSxDQUFDLENBQUM7SUFFL0IsU0FBUyxDQUFDLEdBQUcsRUFBRTtRQUNiLFFBQVEsQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUV0QixJQUFJLFdBQVcsR0FBdUIsR0FBRyxDQUFDLE9BQU8sQ0FBQztRQUNsRCxJQUFJLG9CQUFvQixHQUFHLEtBQUssQ0FBQztRQUVqQyx3REFBd0Q7UUFDeEQsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEVBQUUsSUFBSSxXQUFXLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FBQztZQUMzQyxNQUFNLGVBQWUsR0FDbkIsTUFBTSxDQUFDLGdCQUFnQixDQUFDLFdBQVcsQ0FBQyxDQUFDLGVBQWUsQ0FBQztZQUV2RCxJQUFJLENBQUMsZUFBZSxFQUFFLENBQUM7Z0JBQ3JCLFdBQVcsR0FBRyxXQUFXLENBQUMsYUFBYSxDQUFDO2dCQUN4QyxTQUFTO1lBQ1gsQ0FBQztZQUNELE1BQU0sSUFBSSxHQUFHLFVBQVUsQ0FBQyxlQUFlLENBQUMsQ0FBQztZQUV6Qyx3Q0FBd0M7WUFDeEMsSUFBSSxPQUFPLElBQUksSUFBSSxJQUFJLElBQUksQ0FBQyxLQUFLLEtBQUssQ0FBQyxFQUFFLENBQUM7Z0JBQ3hDLDRCQUE0QjtnQkFDNUIsV0FBVyxHQUFHLFdBQVcsQ0FBQyxhQUFhLENBQUM7Z0JBQ3hDLFNBQVM7WUFDWCxDQUFDO1lBRUQsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ2Ysb0JBQW9CLEdBQUcsSUFBSSxDQUFDO1lBQzVCLE1BQU07UUFDUixDQUFDO1FBRUQsSUFBSSxDQUFDLG9CQUFvQixFQUFFLENBQUM7WUFDMUIsUUFBUSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1FBQ3RCLENBQUM7SUFDSCxDQUFDLEVBQUUsQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUVsQixPQUFPO1FBQ0wsZUFBZSxFQUFFLEtBQUs7UUFDdEIsR0FBRztLQUNKLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLDBCQUEwQixDQUFDIn0=